export enum CityType {
    MoscowAndArea = 1,
    SPB = 2,
    Other = 3,
}
